<template>
  <div class="row row-equal">
    <div class="flex md12">
      <div slot="body">
        <div class="row">
          <div class="flex md2">
            <va-card class="mb-4" color="success">
              <p
                class="display-6 mb-0 text--center"
                style="color: white"
              >{{ nbAdh }} adhérents à jour de cotisation</p>
            </va-card>
          </div>
          <div class="flex md4">
            <va-card class="mb-4 text--center">
              <div class="row row-separated text--center">
                <div class="flex md3 text--center">
                  <p class="display-4 mb-0 text--center" style="color: #40E583">{{ nbCode1 }}</p>
                  <p class="display-8 mb-0 text--center" style="color: black">4723Z</p>
                </div>
                <div class="flex md3 text--center">
                  <p class="display-4 mb-0 text--center" style="color: #40E583">{{ nbCode2 }}</p>
                  <p class="display-8 mb-0 text--center" style="color: black">4781Z</p>
                </div>
                <div class="flex md3 text--center">
                  <p class="display-4 mb-0 text--center" style="color: #40E583">{{ nbCode3 }}</p>
                  <p class="display-8 mb-0 text--center" style="color: black">4638A</p>
                </div>
                <div class="flex md3 text--center">
                  <p class="display-4 mb-0 text--center" style="color: #40E583">{{ nbCodeAutre }}</p>
                  <p class="display-8 mb-0 text--center" style="color: black">Autres / NR</p>
                </div>
              </div>
            </va-card>
          </div>
          <div class="flex md2">
            <va-card class="mb-4" color="info">
              <p
                class="display-7 mb-0 text--center"
                style="color: white"
              >{{ nbSalaries }} salariés dans les entreprises adhérentes</p>
            </va-card>
          </div>
          <div class="flex md2">
            <va-card class="mb-4" color="warning">
              <p
                class="display-7 mb-0 text--center"
                style="color: white"
              >{{ nbAdhExpY }} adhésions expirées depuis moins d'une année</p>
            </va-card>
          </div>
          <div class="flex md2">
            <va-card class="mb-4" color="danger">
              <p
                class="display-7 mb-0 text--center"
                style="color: white"
              >{{ nbAdhExp }} adhésions expirées depuis plus d'une année</p>
            </va-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "DashboardInfoBlock",
  props: ["syndicat"],
  data() {
    return {
      nbAdh: "-",
      nbCode1: "-",
      nbCode2: "-",
      nbCode3: "-",
      nbCodeAutre: "-",
      nbAdhExp: "-",
      nbAdhExpY: "-",
      nbSalaries: "-"
    };
  },
  methods: {
    async init() {
      try {
        let stats = await axios.get("/api/stats-entreprises-syndicat", {
          params: { syndicat: this.syndicat }
        });
        stats = stats.data;
        this.nbAdh = stats.count_ent;
        this.nbCode1 = stats.nb_4723Z;
        this.nbCode2 = stats.nb_4781Z;
        this.nbCode3 = stats.nb_4638A;
        this.nbCodeAutre =
          parseInt(stats.count_ent) -
          parseInt(stats.nb_4723Z) -
          parseInt(stats.nb_4781Z) -
          parseInt(stats.nb_4638A);
        this.nbSalaries = stats.nb_salaries;
        this.nbAdhExp = stats.count_ent_exp;
        this.nbAdhExpY = stats.count_ent_yo;
      } catch (error) {
        console.log(error);
      }
    }
  },
  created() {
    this.init();
  }
};
</script>

<style lang="scss">
.row-separated {
  .flex + .flex {
    border-left: 1px solid #e3eaeb;
  }

  @include media-breakpoint-down(xs) {
    p:not(.display-2) {
      font-size: 0.5rem;
    }
  }
}

.dashboard {
  .va-card__header--over {
    @include media-breakpoint-up(md) {
      padding-top: 0 !important;
    }
  }

  .va-card__image {
    @include media-breakpoint-up(md) {
      padding-bottom: 0 !important;
    }
  }
}
</style>
